<template>
  <div class="modal-overlay">
    <div
      ref="kt_modal_estoques"
      data-bs-backdrop="static"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_estoques"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="card">
              <div class="card-header">
                <div class="card-title d-flex align-items-center">
                  <h3 class="fw-bold m-0 text-gray-800">
                    {{ this.produto.nome }}
                  </h3>
                </div>
                <div
                  class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                  data-bs-dismiss="modal"
                  @click="this.$emit('exibirModalEstoques', false)"
                >
                  <span class="svg-icon svg-icon-1 svg-icon lh-0">
                    <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                  </span>
                </div>
              </div>
              <div class="card-body p-0">
                <div class="card-body pt-5 pb-0">
                  <h4 class="text-primary ms-4">
                    {{
                      this.add === false && this.produto.id_estoque != null
                        ? "Estoque selecionado: " + this.produto.id_estoque
                        : "Selecione o estoque desejado:"
                    }}
                  </h4>
                </div>
                <div class="card-header border-0 pt-0">
                  <div class="card-title">
                    <div
                      class="d-flex align-items-center position-relative my-1"
                    >
                      <span class="svg-icon svg-icon-1 position-absolute ms-6">
                        <inline-svg
                          src="media/icons/duotune/general/gen004.svg"
                        />
                      </span>
                      <input
                        autocomplete="off"
                        type="search"
                        id="txtPesquisarEstoques"
                        v-model="tableData.search"
                        @input="onSearch($event.target.value)"
                        class="form-control form-control-solid w-250px ps-15"
                        placeholder="Pesquisar Estoque"
                        @keydown="keydownPesquisa"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <Datatable
                    ref="table"
                    :table-header="tableHeader"
                    :table-data="tableData"
                    :table-pagination="tablePagination"
                    :page-sizes="pageSizes"
                    :enable-items-per-page-dropdown="true"
                    :hide-on-single-page="false"
                    empty-table-text="Nenhum estoque encontrado"
                    v-on:double-click="selecionarRegistro($event)"
                    v-on:current-row-selected="currentRow = $event"
                    :current-row="currentRow"
                    :showFilters="false"
                  >
                    <template v-slot:cell-id="{ row: estoque }">
                      {{ estoque.id }}
                    </template>
                    <template v-slot:cell-ean="{ row: estoque }">
                      {{ estoque.ean }}
                    </template>
                    <template v-slot:cell-descricao="{ row: estoque }">
                      <div class="min-w-350px align-middle">
                        <div>
                          <span class="text-dark text-hover-primary mb-1">
                            {{ this.getVariacoes(estoque) }}
                          </span>
                          <span class="text-dark text-hover-primary d-block">
                            {{ this.getLotes(estoque) }}
                          </span>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell-qtd="{ row: estoque }">
                      {{ this.$utils.formatarNumero(estoque.qtd) }}
                    </template>
                    <template v-slot:cell-preco="{ row: estoque }">
                      {{ this.$utils.formatarNumero(estoque.preco) }}
                    </template>
                    <template v-slot:cell-acoes="{ row: estoque }">
                      <div>
                        <button
                          type="button"
                          class="btn btn-sm btn-light btn-light-primary my-2 me-2"
                          data-bs-dismiss="modal"
                          @click="this.selecionarRegistro(estoque)"
                        >
                          Selecionar
                        </button>
                      </div>
                    </template>
                  </Datatable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { hideModal } from "@/core/helpers/dom";

export default {
  emits: ["exibirModalEstoques", "confirmarEstoque"],
  components: { Datatable },
  props: {
    add: { type: Boolean, required: true },
    indexEdicao: { type: Number, required: true },
    produto: { type: Object, required: false },
  },
  methods: {
    getLotes(estoque) {
      let result = "";
      if (estoque.lote != null) {
        result += "Lote: " + estoque.lote + " | ";
      }
      if (estoque.data_fabricacao != null) {
        result +=
          "Fabricação: " +
          this.$utils.formatarData(estoque.data_fabricacao) +
          " | ";
      }
      if (estoque.data_vencimento != null) {
        result +=
          "Vencimento: " +
          this.$utils.formatarData(estoque.data_vencimento) +
          " | ";
      }

      return result != "" ? result.substring(0, result.length - 3) : result;
    },
    getVariacoes(estoque) {
      let result = "";
      if (estoque.EstoqueVariacao != null) {
        for (const item of estoque.EstoqueVariacao) {
          result +=
            item.Variacao.descricao +
            ": " +
            item.VariacaoItem.descricao +
            " | ";
        }
      }

      return result != "" ? result.substring(0, result.length - 3) : result;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    selecionarRegistro(estoque) {
      var prod = this.produto;
      if (this.produto.Adicional === null) {
        var variacoes = this.getVariacoes(estoque);
        var lotes = this.getLotes(estoque);
        prod.observacao =
          (variacoes != "" ? variacoes + "\r\n" : variacoes) + lotes;
      }
      prod.preco = estoque.preco > 0 ? estoque.preco : this.produto.preco;
      prod.id_estoque = estoque.id;
      this.$emit("confirmarEstoque", prod, this.add, this.indexEdicao);
      hideModal(this.$refs.kt_modal_estoques);
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(ean, '" +
          pesquisa +
          "') or contains(cod_referencia, '" +
          pesquisa +
          "') or contains(lote, '" +
          pesquisa +
          "') or EstoqueVariacao/any(e: contains(e/Variacao/descricao, '" +
          pesquisa +
          "')) or EstoqueVariacao/any(e: contains(e/VariacaoItem/descricao, '" +
          pesquisa +
          "')) ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async keydownPesquisa(e) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this.currentRow -= 1;
        if (this.currentRow < 0) {
          this.currentRow = 0;
        }
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this.currentRow += 1;
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "Enter") {
        e.preventDefault();
        let registro = this.$refs.table.getCurrentItemIndex(this.currentRow);
        this.selecionarRegistro(registro);
      }
    },
  },
  async mounted() {
    this.tableData.defaultFilter = "id_produto eq " + this.produto.id;
    setTimeout(() => {
      this.nextFocus("txtPesquisarEstoques");
    }, 800);
  },
  data() {
    return {
      currentRow: 0,
      tableHeader: [
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "EAN",
          key: "ean",
          sortable: true,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: false,
        },
        {
          name: "Quantidade",
          key: "qtd",
          sortable: true,
        },
        {
          name: "Preço",
          key: "preco",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "estoque/getEstoqueOData",
        selectOData:
          "?$select=id,ean,qtd,cod_referencia,preco,data_fabricacao,data_vencimento,lote&$expand=EstoqueVariacao($expand=Variacao,VariacaoItem)",
        defaultSort: "id asc",
        defaultFilter: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
